var _rect, _mask, _path, _tspan, _mask2, _path2, _tspan2, _path3, _tspan3, _path4, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 179,
    viewBox: "0 0 411 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1002_43942)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_43942)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 139,
    rx: 10,
    className: "component-background"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1002_43942)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_1002_43942",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16C20.5 12.6863 23.1863 10 26.5 10H384.5C387.814 10 390.5 12.6863 390.5 16V58H20.5V16Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 10H390.5H20.5ZM390.5 59H20.5V57H390.5V59ZM20.5 58V10V58ZM390.5 10V58V10Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-3-inside-1_1002_43942)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 42.71
  }, "TESTKORT")))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_1002_43942",
    maskUnits: "userSpaceOnUse",
    x: 20.5,
    y: 58,
    width: 370,
    height: 44,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 20.5,
    y: 58,
    width: 370,
    height: 44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 58H390.5V101H20.5V58Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390.5 100H20.5V102H390.5V100Z",
    className: "component-divider",
    fillOpacity: 0.15,
    mask: "url(#path-6-outside-2_1002_43942)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 83.9395
  }, "Alternativ 1"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "component-foreground",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.864 72.8437C373.255 72.4532 373.888 72.4532 374.278 72.8437L380.207 78.7724C380.598 79.1629 380.598 79.7961 380.207 80.1866L374.237 86.1563C373.847 86.5468 373.214 86.5468 372.823 86.1563C372.433 85.7658 372.433 85.1326 372.823 84.7421L378.086 79.4795L372.864 74.2579C372.474 73.8674 372.474 73.2342 372.864 72.8437Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "component-foreground",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Roboto",
    fontSize: 13,
    fontWeight: "bold",
    letterSpacing: "0px"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 30.5,
    y: 127.939
  }, "Alternativ 2"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "component-foreground",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.864 116.844C373.255 116.453 373.888 116.453 374.278 116.844L380.207 122.772C380.598 123.163 380.598 123.796 380.207 124.187L374.237 130.156C373.847 130.547 373.214 130.547 372.823 130.156C372.433 129.766 372.433 129.133 372.823 128.742L378.086 123.479L372.864 118.258C372.474 117.867 372.474 117.234 372.864 116.844Z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 10.5,
    width: 369,
    height: 138,
    rx: 9.5,
    className: "component-border",
    strokeOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1002_43942",
    x: 0.5,
    y: 0,
    width: 410,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_43942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_43942",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1002_43942",
    x: 10.5,
    y: 5,
    width: 390,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1002_43942"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1002_43942",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_43942"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 10,
    width: 370,
    height: 139,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestcard);
export default __webpack_public_path__ + "static/media/testcard.7b147a4154dcf4360d6378513490e13a.svg";
export { ForwardRef as ReactComponent };